<template>
  <div class="drs">
    <div class="drs__labels">
        <span>{{ prefix }}{{ modelMin }}{{ suffix }}</span>
        <span>{{ prefix }}{{ modelMax }}{{ suffix }}</span>
    </div>
    <div class="drs__track-wrap">
      <div class="drs__fill" :style="fillStyle"></div>
      <input
        class="drs__input"
        type="range"
        :min="min" :max="max" :step="step"
        :value="modelMin"
        @input="onMinInput"
      />
      <input
        class="drs__input"
        type="range"
        :min="min" :max="max" :step="step"
        :value="modelMax"
        @input="onMaxInput"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DualRangeSlider',
  props: {
    min:      { type: Number, required: true },
    max:      { type: Number, required: true },
    modelMin: { type: Number, required: true },
    modelMax: { type: Number, required: true },
    step:     { type: Number, default: 1 },
    prefix:   { type: String, default: '' },
    suffix:   { type: String, default: '' },
  },
  emits: ['update:modelMin', 'update:modelMax'],
  computed: {
    fillStyle(): object {
      const range = this.max - this.min;
      if (range === 0) return {};
      const left  = ((this.modelMin - this.min) / range) * 100;
      const right = ((this.max - this.modelMax)  / range) * 100;
      return { left: `${left}%`, right: `${right}%` };
    },
  },
  methods: {
    onMinInput(e: Event) {
        const input = e.target as HTMLInputElement;
        const val = Number(input.value);
        const clamped = Math.min(val, this.modelMax - 1);
        input.value = String(clamped);
        this.$emit('update:modelMin', clamped);
    },
    onMaxInput(e: Event) {
        const input = e.target as HTMLInputElement;
        const val = Number(input.value);
        const clamped = Math.max(val, this.modelMin + 1);
        input.value = String(clamped);
        this.$emit('update:modelMax', clamped);
    },
  },
});
</script>

